<template>
	<div class="home">
		<div class="tagsmapPage">
			<Header :type="pageType" />
			<div class="main_page notFound_page">
				<div>
					<img
					 src="@/assets/images/not_found.png"
					 alt="404"
					/>
					<div class="notFound">
						页面不存在,
						<a
						 @mouseenter="showTip=true"
						 @mouseleave="showTip=false"
						 class="notFound_link"
						>
							扫码1V1咨询保险专家

							<div
							 v-show="showTip"
							 class="not_found_popover"
							>
								<img src="@/assets/images/qrcodes/not_found.png"/>
								<div class="popover_content">扫描二维码<br/>1V1咨询保险专家</div>
							</div>
						</a>
						或
						<a
						 class="notFound_link"
						 href="/"
						>回到首页</a>
					</div>
				</div>
			</div>
			<Footer :type="pageType" />
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header';
import Footer from '@/components/Footer';
export default {
	name: 'notFound',
	head() {
		return {
			title: '骆驼规划官网-润安国际保险-专业保险规划机构，省心省钱买对保险',
			meta: [
				{
					name: 'description',
					content:
						'骆驼规划是一家专业中立的第三方保险规划平台，致力于让普通家庭也能享受到量身定制的保险规划服务，提供包括重疾险、医疗险、儿童险、寿险、意外险等在内的保险方案定制、风险评测、理赔协助、保险科普、保险评测等服务。'
				},
				{
					name: 'keywords',
					content: '骆驼规划,保险方案,保险评测,保险理赔'
				}
			]
		};
	},
	components: {
		Header,
		Footer
	},
	data() {
		return {
			pageType: 1,
			showTip: false
		};
	},
	created() { }
};
</script>

<style lang="scss">
@import "@/css/version.scss";
</style>
